import React, { Component } from "react";
import { UIView } from "@uirouter/react";

import Notifications from "components/support/notifications";
import Loader from "components/app/loader";

import "./layout.css";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.router = props.transition.router;
  }

  layout() {
    return (
      <section style={{ height: "100vh", overflow: "hidden" }}>
        <header style={{ display: "flex" }}>
          <UIView name="topbar" />
        </header>
        <Notifications />
        <main
          id={this.router.stateService.current.name || ""}
          style={{
            overflowY: "auto",
            height: "100vh",
            background: "#EAEAEA",
            flexDirection: "row"
          }}
        >
          <UIView name="sidebar" />
          <UIView name="content" />
        </main>
      </section>
    );
  }

  loader() {
    return <Loader onChange={response => this.handleLoaderChange(response)} />;
  }

  render() {
    const { showLoader } = this.props.viewModel;
    return showLoader ? this.loader() : this.layout();
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/support/layout/view.jsx